<template>
  <section>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
    />
    <v-card class="p-0" v-if="id_persona">
      <v-card-text>
        <v-layout row wrap justify-center>
          <v-flex xs12 class="text-xs-center blue--text"
            ><b>{{ $moment(fecha_marcado).format("DD/MM/YYYY") }}</b></v-flex
          >

          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="l_historicos"
              class="elevation-1"
              :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
              :loading="loading"
              item-key="index"
              rows-per-page-text="Filas por pagina"
              :pagination.sync="pagination"
            >
              <template v-slot:headers="props">
                <tr >
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : ''
                    ]"
                    id="cabecera_tabla"
                    class="text-xs-center"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small color="white">arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td class="text-xs-center">
                  <v-flex xs12 class="text-xs-center">
                    <b class="blue--text"
                      >Fecha ajuste:
                      {{
                        $moment(props.item.fecha_ajuste).format(
                          "DD/MM/YYYY  HH:mm:ss"
                        )
                      }}</b
                    >
                    <table class="table-marcado-historico">
                      <tr>
                        <th>Horario</th>
                        <th>Tolerancia</th>
                        <th>Marcado</th>
                        <th>Atraso</th>
                        <th>Descripción</th>
                        <th>Clasifiación</th>
                      </tr>
                      <tr
                        v-for="marcado in props.item.marcados"
                        :key="marcado.id_control_asistencia"
                        :style="
                          marcado.atraso > 0
                            ? 'background:rgb(219, 62, 177,0.3'
                            : marcado.tipo_marcado == 'I'
                            ? 'background:rgb(252, 76, 2,0.3'
                            : ''
                        "
                      >
                        <td style="width: 15%;">{{ marcado.horario }}</td>
                        <td style="width: 15%;">{{ marcado.tolerancia }}</td>
                        <td style="width: 15%">
                          {{
                            marcado.hora_marcada ? marcado.hora_marcada : "-"
                          }}
                        </td>
                        <td style="width: 15%">{{ marcado.atraso }}</td>
                        <td style="width: 55%;">
                          {{ marcado.descripcion_caso }}
                        </td>
                        <td style="width: 55%;">
                          {{ marcado.detalle_marcado }}
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </td>
              </template>
            </v-data-table></v-flex
          >
        </v-layout>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  components: {},
  mixins: [validate],
  props: ["id_persona", "fecha_marcado"],
  data() {
    return {
      valid: false,
      form: {},
      loading: false,
      url_backend: process.env.API_URL.split("api/")[0],
      l_historicos: [],
      // Variables tabla
      pagination: {
        sortBy: ""
      },
      // Variables tabla
      pagination: {
        sortBy: ""
      },
      headers: [
        {
          text: "HISTORICO AJUSTES",
          value: "fecha_ajuste",
          align: "center",
        }
      ]
    };
  },
  watch: {
    async fecha_marcado(old, new_value) {
      this.l_historicos = await this.obtieneSeguimiento(
        this.id_persona,
        this.fecha_marcado
      );
    }
  },
  async created() {
    this.l_historicos = await this.obtieneSeguimiento(
      this.id_persona,
      this.fecha_marcado
    );
  },
  async mounted() {},

  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // Metodo para listar el seguimiento
    async obtieneSeguimiento(id_persona, fecha_marcado) {
      this.loading = true;
      try {
        let rpta = await this.$service.graphql({
          query: `
            query{
              vHistoricoControlAsistencias(id_persona: ${id_persona},fecha_marcado :"${fecha_marcado}"){
                rows{
                  id_persona
                  nombre_usuario
                  fecha_ajuste
                  marcados
                }
              }
          }
        `
        });
        let lista_tmp = rpta.vHistoricoControlAsistencias.rows;
        this.loading = false;
        return lista_tmp;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss">
.table-marcado-historico {
  min-width: 100%;
  tr {
    min-width: 100%;
    text-align: center;
    th {
      height: 1em !important;
      color: rgba(2, 96, 202, 0.884);
      font-weight: bold;
      font-size: 0.9em;
      border-bottom: 1px solid rgba(2, 69, 156, 0.274);
      padding: 0px 0.2em 0px 0.2em !important;
    }
    td {
      height: 1em !important;
      font-size: 0.9em !important;
      text-align: center;
      padding: 0px 0.2em 0px 0.2em !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/tipificacion/components/HistoricoAjustes.vue